import { ReactNode } from "react";
import { Icon } from "../icons/icon";

export const TextInputViewOnly = ({
  className,
  text,
  subtext,
  hasIcon,
  icon = "warning-icon",
  plain = false,
  extraContent = undefined,
  hasTitle = false,
  title = "",
}: {
  className?: string;
  text: string;
  subtext?: string;
  hasIcon?: boolean;
  icon?: string;
  plain?: boolean;
  extraContent?: ReactNode;
  hasTitle?: boolean;
  title?: string;
}) => {
  return (
    <div className="w-full">
      {hasTitle && (
        <p className="text-sm text-pry-dark-green-300/80 font-medium mb-1">
          {title}
        </p>
      )}

      <div
        className={`
        w-full py-3 px-4 md:px-6
        flex flex-row rounded-[8px]
        items-center justify-between
        bg-light-green-bg border border-light-green-bg
        ${plain && `!bg-transparent !border-transparent`}
        ${className}
        `}
      >
        <div className="text-sm">
          <p className={`${plain ? "font-medium md:text-base" : "font-bold"}`}>
            {text}
          </p>

          <p className={`mt-1 ${plain && "text-pry-dark-green-300/50 !mt-0"}`}>
            {subtext}
          </p>

          {extraContent && <div className="pt-1">{extraContent}</div>}
        </div>

        {hasIcon && (
          <Icon
            svg={icon}
            width={24}
            height={24}
            className="text-pry-green-200"
          />
        )}
      </div>
    </div>
  );
};
